<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Utilizar Fianza</p>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" v-model="validForm" lazy-validation>
                            <template v-if="!mostrar">
                                <label class="typo__label">Afianzadora:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ this.datos.afnombre }}
                                </label>
                                <br />
                                <v-divider class="margin"></v-divider>
                                <label class="typo__label">Folio:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ this.datos.fifolio }}
                                </label>
                                <br />
                                <v-divider class="margin"></v-divider>
                            </template>
                            <template v-if="mostrar">
                                <label class="typo__label">Asegurado:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ this.datosResp.asnombre }}
                                </label>
                                <br />
                                <v-divider class="margin"></v-divider>
                                <label class="typo__label">Aseguradora:</label>
                                <br>
                                <label class="typo__label font-weight-bold sub-Fia">
                                    {{ this.datosResp.clnombre }}
                                </label>
                                <br />
                                <v-divider class="margin"></v-divider>
                            </template>


                            <label class="typo__label">Abogado:</label>
                            <br>
                            <label class="typo__label font-weight-bold sub-Fia">
                                {{ this.datos.responsable }}
                            </label>
                            <br />
                            <v-divider class="margin"></v-divider>

                            <span class="type-label-style">Fecha de aplicación:</span>
                            <v-dialog ref="dialog" outlined v-model="modal"
                                :return-value.sync="datosBusqueda.selectedDate" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="date-align-center">
                                        <v-text-field v-model="datosBusqueda.selectedDate" label="" readonly outlined
                                            :disabled="mostrar || block" :filled="mostrar || block" dense v-bind="attrs"
                                            v-on="on" :error-messages="validation.errorFecha"
                                            ref="datosBusqueda.selectedDate"></v-text-field>
                                    </div>
                                </template>
                                <v-date-picker v-model="datosBusqueda.selectedDate" locale="es-mx" :min="minfecha"
                                    :max="startdate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="secondary" @click="modal = false">
                                        Cancelar
                                    </v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(datosBusqueda.selectedDate)">
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">Reporte:</label>
                            <v-text-field v-model="datosBusqueda.reporte"
                                v-on:blur="datosBusqueda.reporte = datosBusqueda.reporte != null ? datosBusqueda.reporte.trim() : null"
                                outlined :disabled="mostrar || block" :filled="mostrar || block" :rules="rulestext"
                                @keypress="filter()" :error-messages="validation.reporte" maxlength="10" dense>
                            </v-text-field>
                            <label class="typo__label">Indice:</label>
                            <v-text-field v-model="datosBusqueda.indice"
                                v-on:blur="datosBusqueda.indice = datosBusqueda.indice != null ? datosBusqueda.indice.trim() : null"
                                outlined :disabled="mostrar || block" :filled="mostrar || block" :rules="rulestext"
                                @keypress="filter()" :error-messages="validation.indice" maxlength="3" dense>
                            </v-text-field>
                            <span v-if="validarReporte" style="color: #FF5C93;">El reporte no existe</span>
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">Importe:</label>
                            <v-text-field v-model="datosBusqueda.importe"
                                v-on:blur="datosBusqueda.importe = datosBusqueda.importe != null ? datosBusqueda.importe.trim() : null"
                                outlined :disabled="mostrar || block" :filled="mostrar || block" :rules="rulestext"
                                @keypress="filter()" :error-messages="validation.importe" maxlength="8" dense>
                            </v-text-field>
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">Concepto:</label>
                            <multiselect v-model="datosBusqueda.concepto"
                                deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                select-label="Seleccionar concepto" required :disabled="mostrar || block"
                                :filled="mostrar || block" :error-messages="validation.errorConcepto" track-by="valor"
                                label="concepto" placeholder="Seleccionar concepto" :options="conceptos"
                                :allow-empty="false">
                            </multiselect>
                            <span v-if="showResp" style="color: #FF5C93;"> Debes seleccionar un concepto </span>
                            <v-divider class="margin"></v-divider>
                            <v-card-actions v-if="mostrar == false">
                                <v-spacer></v-spacer>
                                <v-btn class="ma-2" color="#536DFE" title="Aceptar" v-if="block == false"
                                    @click="Aceptar()">
                                    <span class="color">Aceptar</span>
                                </v-btn>
                                <v-btn class="ma-2" v-if="block == false" v-on:click="limpiar(1)" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn color="error" class="ma-2" v-on:click="regresar()">
                                    Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-form>
                    </v-col>
                    <v-col v-if="mostrar" cols="12" md="6">
                        <v-form ref="form2" v-model="validForm" lazy-validation>
                            <label class="typo__label">Conductor:</label>
                            <br>
                            <label class="typo__label font-weight-bold sub-Fia">
                                {{ this.datosResp.svnomcond }}
                            </label>
                            <br />
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">Corresponde al nombre del
                                fiado:</label>
                            <br>
                            <v-radio-group v-model="datosBusqueda.radio" row>
                                <v-radio label="SI" value="S"></v-radio>
                                <v-radio label="NO" value="N"></v-radio>
                            </v-radio-group>
                            <span v-if="validaradio" class="spanError" style="color: #FF5C93; font-size: 12px">
                                El campo es obligatorio
                            </span>
                            <br />
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">RFC:</label>
                            <v-text-field v-model="datosBusqueda.rfc"
                                v-on:blur="datosBusqueda.rfc = datosBusqueda.rfc != null ? datosBusqueda.rfc.trim() : null"
                                outlined :rules="rulestextRFC" :error-messages="validation.rfc" maxlength="13" dense
                                @keypress="validarRegex($event, 'NL')">
                            </v-text-field>
                            <v-divider class="margin"></v-divider>
                            <label class="typo__label">Domicilio:</label>
                            <v-text-field v-model="datosBusqueda.domicilio"
                                v-on:blur="datosBusqueda.domicilio = datosBusqueda.domicilio != null ? datosBusqueda.domicilio.trim() : null"
                                outlined maxlength="100" dense>
                            </v-text-field>
                            <v-divider class="margin"></v-divider>
                            <template v-if="varios">
                                <label class="typo__label">Obligaciones Procesales:</label>
                                <v-text-field v-model="datosBusqueda.obligacion"
                                    v-on:blur="datosBusqueda.obligacion = datosBusqueda.obligacion != null ? datosBusqueda.obligacion.trim() : null"
                                    outlined @keypress="filter()" :error-messages="validation.obligacion" maxlength="30"
                                    dense>
                                </v-text-field>
                                <v-divider class="margin"></v-divider>
                                <label class="typo__label">Sanciones Pecuniarias:</label>
                                <v-text-field v-model="datosBusqueda.sanciones"
                                    v-on:blur="datosBusqueda.sanciones = datosBusqueda.sanciones != null ? datosBusqueda.sanciones.trim() : null"
                                    outlined @keypress="filter()" :error-messages="validation.sanciones" maxlength="30"
                                    dense>
                                </v-text-field>
                                <v-divider class="margin"></v-divider>
                                <label class="typo__label">Garantia por reparacion:</label>
                                <v-text-field v-model="datosBusqueda.garantia"
                                    v-on:blur="datosBusqueda.garantia = datosBusqueda.garantia != null ? datosBusqueda.garantia.trim() : null"
                                    outlined @keypress="filter()" :error-messages="validation.garantia" maxlength="30"
                                    dense>
                                </v-text-field>
                                <span v-if="validarconceptos" class="spanError" style="color: #FF5C93; font-size: 12px">
                                    Favor de llenar por lo menos dos conceptos
                                </span>
                                <v-divider class="margin"></v-divider>
                                <label class="typo__label">Total:</label>
                                <v-text-field v-model="datosBusqueda.total"
                                    v-on:blur="datosBusqueda.total = datosBusqueda.total != null ? datosBusqueda.total.trim() : null"
                                    outlined @keypress="filter()" :error-messages="validation.total" maxlength="30"
                                    dense>
                                </v-text-field>
                            </template>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="ma-2" color="#536DFE" title="Grabar" @click="UtilizarFianza()">
                                    <span style="color: white">Grabar</span>
                                </v-btn>
                                <v-btn class="ma-2" v-on:click="limpiar(2)" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn color="error" class="ma-2" v-on:click="regresar()">
                                    Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';
import moment from "moment";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            datosBusqueda: {
                monto: null,
                concepto: null,
                reporte: null,
                indice: null,
                importe: null,
                radio: null,
                rfc: null,
                selectedDate: null,
                domicilio: null,
                obligacion: null,
                sanciones: null,
                garantia: null,
                total: null,
            },
            rulestext: [
                v => {
                    if (v == null || v == '') {
                        return 'El campo es obligatorio'
                    }
                    else {
                        if (v.length < 1) {
                            return 'El campo es obligatorio'
                        }
                        else
                            return true
                    }
                },
            ],
            rulestextRFC: [
                v => {
                    if (v == null || v == '') {
                        return 'El campo es obligatorio'
                    }
                    else {
                        // Expresión regular para validar RFC de personas físicas
                        const rfcPersonaFisicaRegex = /^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/
                        // Expresión regular para validar RFC de personas morales
                        const rfcPersonaMoralRegex = /^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/
                        if (!rfcPersonaFisicaRegex.test(v.toUpperCase()) && !rfcPersonaMoralRegex.test(v.toUpperCase())) {
                            return 'Debes ingresar un RFC válido';
                        } else {
                            return true;
                        }
                    }
                },
            ],
            validForm: true,
            minfecha: '',
            startdate: '',
            showcargando: true,
            validation: {
                errorConcepto: '',
            },
            responsablesArray: [],
            estatusArray: [],
            modal: false,
            showResp: false,
            conceptos: [],
            datos: '',
            mostrar: false,
            datosResp: [],
            varios: false,
            validaradio: false,
            block: false,
            validarconceptos: false,
            validarReporte: false,

        }
    },
    watch: {
        'datosBusqueda.concepto'(val) {
            this.showResp = false;
        },
        'datosBusqueda.radio'(val) {
            this.validaradio = false;
        },
        'datosBusqueda.obligacion'() {
            this.validarconceptos = false;
        },
        'datosBusqueda.garantia'() {
            this.validarconceptos = false;
        },
        'datosBusqueda.sanciones'() {
            this.validarconceptos = false;
        },
        'datosBusqueda.reporte'() {
            this.validarReporte = false;
        },
        'datosBusqueda.indice'() {
            this.validarReporte = false;
        }

    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        async limpiar(tipo) {
            if (tipo == 1) {
                await this.$refs.form.reset();
                this.showResp = false;
                this.validaradio = false;
                this.datosBusqueda.concepto = null
                this.datosBusqueda.selectedDate = moment().format("YYYY[-]MM[-]DD");
            } else {
                await this.$refs.form2.reset();
                this.validaradio = false;
                this.validarconceptos = false
            }
        },
        async Aceptar() {
            var errorCounter = 0;
            if (this.datosBusqueda.concepto == null) {
                this.validation.errorConcepto = 'Seleccione una opción';
                this.showResp = true;
                errorCounter++;
            }
            if (this.datosBusqueda.reporte != null && this.datosBusqueda.indice != null) {
                var formData = new FormData();
                formData.append("nrreporte", this.datosBusqueda.reporte);
                formData.append("svindice", this.datosBusqueda.indice);
                let response = await Fianzas.ValidarReporte(formData);
                if (response == 0) {
                    this.validarReporte = true;
                    errorCounter++;
                }
            }
            this.$refs.form.validate();
            if (errorCounter == 0 && this.$refs.form.validate()) {
                let formData = new FormData();
                formData.append("reporte", this.datosBusqueda.reporte);
                formData.append("svindice", this.datosBusqueda.indice);
                this.datosResp = await Fianzas.VerificarReporte(formData);
                if (this.datosResp.mensaje == "OK") {
                    this.mostrar = true;
                    this.varios = this.datosBusqueda.concepto.valor == '' ? true : false;
                }
            }
        },
        async UtilizarFianza() {
            var errorCounter = 0;
            if (this.datosBusqueda.radio == null) {
                this.validaradio = true;
                errorCounter++;
            }
            if (this.varios == true) {
                let contador = 0
                if (this.datosBusqueda.obligacion == null || this.datosBusqueda.obligacion == '') { contador++; }
                if (this.datosBusqueda.garantia == null || this.datosBusqueda.garantia == '') { contador++; }
                if (this.datosBusqueda.sanciones == null || this.datosBusqueda.sanciones == '') { contador++; }
                if (contador > 1) {
                    this.validarconceptos = true;
                    errorCounter++;
                }
            }
            this.$refs.form2.validate();
            if (errorCounter == 0 && this.$refs.form2.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("afc", this.datos.afclave);
                        formData.append("fifol", this.datos.fifolio);
                        formData.append("fifecap", this.datosBusqueda.selectedDate);
                        formData.append("ficp", this.datosBusqueda.concepto.concepto);
                        formData.append("svrep", this.datosBusqueda.reporte);
                        formData.append("svin", this.datosBusqueda.indice);
                        formData.append("ficorre", this.datosBusqueda.radio);
                        formData.append("svfirfc", this.datosBusqueda.rfc);
                        formData.append("svdir", this.datosBusqueda.domicilio);
                        formData.append("claveConce", this.datosBusqueda.concepto.valor);
                        formData.append("fiimp", this.datosBusqueda.importe);
                        formData.append("Tot", this.datosBusqueda.total);
                        formData.append("OPro", this.datosBusqueda.obligacion);
                        formData.append("SPecu", this.datosBusqueda.sanciones);
                        formData.append("GRep", this.datosBusqueda.garantia);
                        let data = await Fianzas.UtilizarFianza(formData);
                        if (data) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se utilizó la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.regresar()
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al utilizar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }
                });
            }
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async regresar() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
        }

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15,317").then((response) => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 15)//acceso al módulo de contraloría Normativa 
                        this.permisoContraloria = true;
                    if (permiso.peclave == 317)//Permiso para fianzas
                        this.permisoFianzas = true;
                })

                if (!this.permisoContraloria || !this.permisoFianzas) {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('fianza');
        this.responsablesArray = await Fianzas.ObtenerResponsables();
        this.conceptos = await Fianzas.ConceptosFianza();

        let today = new Date().toJSON().slice(0, 10);
        this.datosBusqueda.selectedDate = today;
        this.startdate = today;
        this.minfecha = moment().subtract(3, "d").format("YYYY[-]MM[-]DD");


        this.showcargando = false;
        if (this.datos.fifecentregada != "" || this.datos.fiestatus != "Asignada") {
            this.block = true;
            this.$swal({
                position: 'center',
                icon: 'info',
                title: 'Para utilizar una fianza debe tener un estatus de asignada y no estar entregada',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        }
    },
}
</script>

<style scoped>
.sub-Fia {
    font-size: 18px;
}

.margin {
    margin: 2vh 0;
}

.color {
    color: white
}
</style>
